import React from 'react';
import api from "./../../../services/api";
//import { NavLink } from 'react-router-dom';
import './../../../pages/Representante_Instituição/Tela_RI_Cadastro/styles.css';
import './../../../pages/Representante_Instituição/Tela_RI_Pacientes_Cadastro/styles.css';
import GetAgent from './GetAgent';
import { user_token } from '../../../services/Auth';
import "./style.css";
import Grid from '@material-ui/core/Grid';
import SideNav from './../../../components/SideNav_PS';
import GetProfessional from './GetProfessional';
import GetUser from './GetUser';
//import SwitchButton from "./SwitchButton";

//import da API
import { professional } from './../../../services/api'
let apiProfessional = new professional();

var token = localStorage.getItem(user_token);

export default class FormsAgendamento extends React.Component {

  state = {
    exames: [],
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    const { id } = this.props.match.params;
    console.log(id);
    //const request = await api.get(`/exam/${id}`, {headers: {'x-access-token': token}});
    const request = await apiProfessional.getExam(id);
    console.log(request);
    console.log(request.data);
    this.setState({ exames: request.data });

  };

  render() {
    return (
      <>
        <SideNav />
        <div id="top-PS">
          <Grid container spacing={0} direction="row" justify="left" alignItems="center" style={{ marginTop: '-35vh' }}>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center">

            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10}></Grid>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center">
            </Grid>
          </Grid>
        </div>
        <Grid container spacing={0} direction="row" justify="left" alignItems="center">
          <Grid item xs={12} sm={12} md={10} lg={3} align="center"></Grid>
          <Grid item xs={12} sm={12} md={10} lg={6} align="center">
            <div id="main-RI-Consulta-Pendente">
              <h1 id="title">Consulta Confirmada</h1>
              <br></br>
              <div id="lista-style">
                {this.state.exames.map(details => (
                  <>
                    <div id="exam">

                      <h1 id="tittle-forms-cme">Informações da Instituição</h1>
                      <hr id="coloring_line" />
                      <GetAgent agent_id={details.agent_id} />
                      <hr id="coloring_line" />

                      <br></br>

                      <h1 id="tittle-forms-cme">Informações do(a) Profissional de Saúde</h1>
                      <hr id="coloring_line" />
                      <GetProfessional />
                      <hr id="coloring_line" />

                      <br></br>

                      <h1 id="tittle-forms-cme">Informações do Pedido da Consulta</h1>
                      <hr id="coloring_line" />
                      <p id="RI-Title-Cadastro-Paciente">Tipo da Consulta:</p><p>{details.appointment_type}</p>
                      <p id="RI-Title-Cadastro-Paciente">Especialidade: </p><p>{details.medical_appointment_type}</p>
                      <p id="RI-Title-Cadastro-Paciente">Motivo da Consulta: </p><p>{details.appointment_purpose}</p>
                      <p id="RI-Title-Cadastro-Paciente">Turno de atendimento solicitado: </p><p>{details.appointment_period}</p>
                      <p id="RI-Title-Cadastro-Paciente">Data/Hora marcados para o atendimento:</p><p>{details.appointment_date}</p>
                      <p id="RI-Title-Cadastro-Paciente">Obervações feitas pelo paciente:</p><p>{details.notes}</p>
                      <hr id="coloring_line" />
                      <br></br>

                      <h1 id="tittle-forms-cme">Informações do(a) Paciente</h1>
                      <hr id="coloring_line" />
                      <GetUser user_id={details.user_id} exam_id={details._id} meeting_link={details.meeting_link}/>
                      <br></br>

                    </div>
                    <br></br>
                  </>
                ))}
              </div>
            </div>
          </Grid>
        </Grid>
      </>
    );
  }
}
